import { useLocation, useNavigate } from "react-router";
import "./GlobelSearch.scss";
import { arrowgap, backblack, dataLoading } from "../../assets/assets";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import toastr from "../elements/toast";
import { useSelector } from "react-redux";
import httpApiCall from "../../service/api.service";
import NoDataRightScreen from "../NoDataRightScreen/NoDataRightScreen";

const GlobelSearch = (prop: any) => {
  const toastrService = new toastr(true);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [globelData, setGlobelData] = useState<any>([]);
  const [shimmerEffect, setShimmerEffect] = useState(false);
  const userData = useSelector((state: any) => {
    const partnerData =  state?.APIData?.partnerData;
    console.log(partnerData,"partnerData");

    return partnerData && partnerData.partner_profile && partnerData.partner_profile.length > 0 ? partnerData : null;
  });
  console.log(userData,"userData");
  
  useEffect(() => {
    if(userData){
    searchBar(state.searchString);
    }
  }, [userData]);

  const businessDetail = (dataValue: any, i: any, getno: any) => {
    // console.log(dataValue, i);
    if (dataValue && getno == 0) {
      navigate(`/app/business?referCode=${dataValue.referral_code}`);
    }
    if (dataValue && getno == 1) {
      navigate(`/app/sub-partner?referCode=${dataValue.agent_referral_code}`);
    }
  };
  const searchBar = async (value: any) => {
    setShimmerEffect(true);
    let body = {
      access_token:  userData && userData?.partner_profile[0] && userData?.partner_profile[0]?.access_token,
      search_string: value,
      para_id: userData?.partner_profile[0]["para_id"],
      partner_json: userData?.partner_profile[0]["partner_json"],
    };
    await httpApiCall({ api: "search", type: "POST", body })
      .then((data) => {
        setShimmerEffect(false);
        if (data && !data.is_error) {
          // console.log(data);
          if (
            data &&
            (data.agent_list || data.doctor_list) &&
            (data.agent_list.length > 0 || data.doctor_list.length > 0)
          ) {
            setGlobelData(data);
          } else {
            // toastrService.showError("No data found");
            // return;
          }
        } else {
          toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log("error");
      });
  };

  return (
    <>
     {!shimmerEffect && (globelData && (!globelData.agent_list && !globelData.doctor_list)) && <div className="nocompo">
                      <NoDataRightScreen />
                    </div>}
      {shimmerEffect ? (
        <div className="no_data_v2 text-center">
          <img src={dataLoading} alt="" />
        </div>
      ) : (
        <div>
          <div className="back">
            <button
              className="mb-0 border-0 bg-transparent"
              onClick={() => navigate("/app/dashboard")}
            >
              {" "}
              <img src={backblack} alt="" />
              Back
            </button>
          </div>
          <div className="global-header">
            <h3 className="main-heading">
              {globelData && (globelData["doctor_list"] || globelData["agent_list"]) && (globelData["doctor_list"].length + globelData["agent_list"].length)
                }{" "}
              result(s) found
            </h3>
            <p className="main-para">
              Search result(s) for <span>"{state?.searchString}"</span>{" "}
            </p>
          </div>
          <div className="globel">
            {globelData &&
              globelData["doctor_list"] &&
              globelData["doctor_list"].length > 0 && (
                <div className="globel_business">
                  <div className="globel_business_one">
                    <p>
                      Business(
                      {globelData &&
                        globelData["doctor_list"] &&
                        globelData["doctor_list"].length}
                      )
                    </p>
                  </div>
                  {globelData &&
                    globelData["doctor_list"] &&
                    globelData["doctor_list"].map((item: any, index: any) => (
                      <div className="globel_business_two" key={index}>
                        <div className="data">
                          <p className="name">
                            {item.doctor_first_name}
                            {item.doctor_last_name}
                            <div className="act_inact">
                              <span>{item.active_inactive_status}</span>
                            </div>
                          </p>
                          <p className="registration">
                            Registration Date:{" "}
                            <span>
                              {new Date(
                                item.date_registered
                              ).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                              })}
                            </span>
                          </p>
                          <p className="registration">
                            Added by: <span>{item.partner_name}</span>
                          </p>
                          <div
                            key={index}
                            onClick={() => businessDetail(item, index, 0)}
                          >
                            <p className="view">
                              View Detail <img src={arrowgap} alt="" />
                            </p>
                          </div>
                        </div>
                        <div className="data">
                          <p className="registration">
                            Id :<span>{item.referral_code}</span>
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            {globelData && globelData["agent_list"]?.length > 0 && (
              <div className="globel_business">
                <div className="globel_business_one">
                  <p>
                    Sub Partner(
                    {globelData && globelData["agent_list"]?.length})
                  </p>
                </div>
                {globelData &&
                  globelData["agent_list"].map((item: any, index: any) => (
                    <div className="globel_business_two" key={index}>
                      <div className="data">
                        <p className="name">
                          {item.agent_name}
                          <div className="act_inact">
                            <span>{item.last_30_days_active}</span>
                          </div>
                        </p>
                        <p className="registration">
                          Registration Date:{" "}
                          <span>
                            {new Date(item.date_registered).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                              }
                            )}
                          </span>
                        </p>
                        <p className="registration">
                          Added by: <span>{item.added_by}</span>
                        </p>
                        <div
                          key={index}
                          onClick={() => businessDetail(item, index, 1)}
                        >
                          <p className="view">
                            View Detail <img src={arrowgap} alt="" />
                          </p>
                        </div>
                      </div>
                      <div className="data">
                        <p className="registration">
                          Id :<span>{item.agent_referral_code}</span>
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default GlobelSearch;
